<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        lg="4"
        v-for="binder in filteredBinders"
        v-bind:key="binder.binderId"
      >
        <binder :binder-data="binder"></binder>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState: customerMapState } = createNamespacedHelpers("customer/");
const { mapState: filtersMapState } = createNamespacedHelpers("filters/");
import Binder from "./Binder";

function filterByBrand(binders) {
  if (this.brandFilter.length) {
    binders = binders.filter(binder => {
      return this.brandFilter.indexOf(binder.brandId) !== -1;
    });
  }
  return binders;
}

function filterByText(binders) {
  if (this.textFilter.length) {
    binders = binders.filter(binder =>
      binder.name.toLowerCase().includes(this.textFilter.toLowerCase())
    );
  }
  return binders;
}

export default {
  name: "Library",
  components: {
    Binder
  },
  computed: {
    ...customerMapState(["library"]),
    ...filtersMapState(["brandFilter", "textFilter"]),
    filteredBinders() {
      let binders = this.library;

      binders = filterByBrand.call(this, binders);

      binders = filterByText.call(this, binders);

      return binders;
    }
  }
};
</script>

<style scoped></style>
